import { addLineItemToTransaction } from 'src/home-page/business-logic/sale-mode-router';
import { ILineItemAddData } from 'src/items-list/business-logic/line-item-add';
import { PriceModifierType } from 'src/items-list/business-logic/service/interfaces/line-item-add.dto';
import { LineModifiersMethodCodes } from '../../common/enumerations/line-modifiers-methods';

export const sellPriceEntryItem = async (
  lineItemData: ILineItemAddData,
  newPrice: number,
  isPriceVerify: boolean,
): Promise<void> => {
  lineItemData.lineItem.modifiers = [LineModifiersMethodCodes.RequiredPrice];
  lineItemData.lineItem.priceModifierType = isPriceVerify
    ? PriceModifierType.PriceVerify
    : PriceModifierType.ResetPrice;
  lineItemData.lineItem.newPrice = newPrice;
  return addLineItemToTransaction(lineItemData);
};
